import { motion } from "framer-motion";
import { Reveal } from "../motion/Reveal";
import { Stagger, StaggerItem } from "../motion/Stagger";

const steps = [
  {
    n: "01",
    title: "Prise de contact",
    text: "Vous nous contactez par formulaire ou téléphone. Nous convenons d'une visite gratuite sur site.",
  },
  {
    n: "02",
    title: "Audit & devis",
    text: "Nous analysons vos besoins, vos contraintes horaires, la surface et les prestations. Devis clair sous 48 h.",
  },
  {
    n: "03",
    title: "Mise en place",
    text: "Cahier des charges signé, planning validé et installation du carnet de passage.",
  },
  {
    n: "04",
    title: "Suivi qualité",
    text: "Contrôles terrain, point mensuel, ajustements et garantie satisfaction : nous restons à votre écoute.",
  },
];

export function Process() {
  return (
    <section className="section bg-white">
      <div className="container-page">
        <Reveal as="header" className="max-w-2xl">
          <span className="eyebrow">Notre processus</span>
          <h2 className="mt-4">Une démarche simple, transparente, rassurante</h2>
        </Reveal>

        <Stagger
          as="ol"
          className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-4 relative"
          staggerChildren={0.1}
        >
          <div
            aria-hidden="true"
            className="hidden lg:block absolute top-14 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-transparent via-brand-300 to-transparent"
          />
          {steps.map((s) => (
            <StaggerItem key={s.n} as="li">
              <motion.div
                whileHover={{ y: -4 }}
                transition={{ type: "spring", stiffness: 260, damping: 22 }}
                className="relative h-full rounded-2xl bg-gradient-to-br from-brand-50 via-white to-white border border-brand-100 p-6 overflow-hidden"
              >
                <div
                  aria-hidden="true"
                  className="absolute -top-6 -right-6 h-24 w-24 rounded-full bg-brand-200/40 blur-2xl"
                />
                <div className="relative font-display font-bold text-4xl bg-gradient-to-br from-brand-400 to-brand-700 bg-clip-text text-transparent">
                  {s.n}
                </div>
                <h3 className="relative mt-2 text-lg">{s.title}</h3>
                <p className="relative mt-2 text-sm text-ink-muted leading-relaxed">{s.text}</p>
              </motion.div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
